module.exports = __webpack_public_path__ + "static/media/Decoy Effect, Asymmetric Dominance Effect.7469d577.jpg";